import { TextInput } from '@mantine/core';
import InputMention from 'pages/revisions-module/template-editor/editors/InputMention';
import { IFormInputSpecFieldUpdatedAt } from 'pages/revisions-module/template-editor/editors/form/types';

/**
 * Preview for the field-updated-at input type.
 */
export default function FieldUpdatedAtInputPreview({ spec }: { spec: IFormInputSpecFieldUpdatedAt }) {
  return (
    <TextInput
      size="sm"
      readOnly
      placeholder="Čas poslednej zmeny"
      description={<InputMention name={spec.sourceField || ''} prefix="Sledované pole:" />}
    />
  );
}
